import XcHorizontalRule from "@electricMotorShop/Widgets/Basic/XcHorizontalRule";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import Clickable, { ClickablePresentationProps } from "@insite/mobius/Clickable";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React from "react";
import { css } from "styled-components";

interface OwnProps {
    panelTitle?: string;
    panelUrl?: string;
    closeOverlay?: () => void;
}

type XcPanelShopAllProps = OwnProps;

interface XcPanelShopAllStyles {
    panelRow?: InjectableCss;
    contentWrapper?: InjectableCss;
    innerContentWrapper?: InjectableCss;
    title?: TypographyPresentationProps;
    button?: ClickablePresentationProps;
    buttonText?: TypographyPresentationProps;
}

const xcPanelShopAllStyles: XcPanelShopAllStyles = {
    panelRow: {
        css: css`
            background: ${getColor("primary.contrast")};
            color: ${getColor("text.main")};
            padding: 0;
        `,
    },
    contentWrapper: {
        css: css`
            width: 100%;
            display: flex;
            flex-direction: column;
        `,
    },
    innerContentWrapper: {
        css: css`
            width: 100%;
            display: flex;
            flex-direction: row;
            align-items: center;
            padding: 10px 10px 10px 20px;
        `,
    },
    title: {
        css: css`
            font-weight: 700;
            margin-right: 8px;
            flex: 1;
        `,
    },
    button: {
        css: css`
            background: ${getColor("primary.main")};
            padding: 6px;
            border-radius: 4px;
            margin-left: auto;
        `,
    },
    buttonText: {
        css: css`
            color: ${getColor("primary.contrast")};
            font-weight: bold;
        `,
    },
};

const styles = xcPanelShopAllStyles;

const XcPanelShopAll = (props: XcPanelShopAllProps) => {
    const { panelTitle, panelUrl, closeOverlay } = props;

    const fullPanelTitle = `All ${panelTitle}`;

    return (
        <StyledWrapper {...styles.contentWrapper}>
            <StyledWrapper {...styles.innerContentWrapper}>
                <Typography className="main-navigation-row-text" {...styles.title}>
                    {fullPanelTitle}
                </Typography>
                <Clickable href={panelUrl} onClick={closeOverlay} {...styles.button}>
                    <Typography {...styles.buttonText}>{translate("Shop All")}</Typography>
                </Clickable>
            </StyledWrapper>
            <XcHorizontalRule />
        </StyledWrapper>
    );
};

export default XcPanelShopAll;
